import { Divider } from "primereact/divider";
export default function Statistic(props) {
  const { title, count, key, isLastElement } = props;
  return (
    <div className="flex flex-column" key={key}>
      <div className="flex align-items-center justify-content-between">
        <span className="text-xl text-tremor-default text-tremor-content dark:text-dark-tremor-content">
          {title}
        </span>
        <p className="text-2xl text-tremor-content-strong dark:text-dark-tremor-content-strong font-semibold pl-3">
          {count}
        </p>
      </div>
      {!isLastElement && (<Divider />)}
    </div>
  );
}
